import { useTranslation } from 'react-i18next';
import propTypes from 'prop-types';
import * as S from './styles';

const LogoCard = ({ logoUrl }) => {
  const [t] = useTranslation('personalized-invite');

  return (
    <S.Card>
      <S.LogoImage src={logoUrl} alt={t('logo-alt')} />
    </S.Card>
  );
};

LogoCard.propTypes = {
  logoUrl: propTypes.string.isRequired,
};

export default LogoCard;
